const dryCleaningHouse = [
	{
		id: '4301',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Duvet / Blanket / Quilt / Comforter (Single)',
		category: 'Household',
		service: 'Dry Cleaning',
		price: 150,
		quantity: 1
	},
	{
		id: '4302',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Duvet / Blanket / Quilt / Comforter (Double)',
		category: 'Household',
		service: 'Dry Cleaning',
		price: 200,
		quantity: 1
	},
	{
		id: '4303',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Bed Sheet(Single)',
		category: 'Household',
		service: 'Dry Cleaning',
		price: 50,
		quantity: 1
	},
	{
		id: '4304',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Bed Sheet(Double)',
		category: 'Household',
		service: 'Dry Cleaning',
		price: 100,
		quantity: 1
	},
	{
		id: '4305',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Door Mat',
		category: 'Household',
		service: 'Dry Cleaning',
		price: 80,
		quantity: 1
	},
	{
		id: '4306',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Sofa Cover',
		category: 'Household',
		service: 'Dry Cleaning',
		price: 120,
		quantity: 1
	},
	{
		id: '4307',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Light Carpet',
		category: 'Household',
		service: 'Dry Cleaning',
		price: 100,
		quantity: 1
	},
	{
		id: '4308',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Fluffy Carpet',
		category: 'Household',
		service: 'Dry Cleaning',
		price: 150,
		quantity: 1
	},
	{
		id: '4309',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Towel',
		category: 'Household',
		service: 'Dry Cleaning',
		price: 60,
		quantity: 1
	},
	{
		id: '4310',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Pillow',
		category: 'Household',
		service: 'Dry Cleaning',
		price: 80,
		quantity: 1
	},
	{
		id: '4311',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Travel Bag',
		category: 'Household',
		service: 'Dry Cleaning',
		price: 100,
		quantity: 1
	}
];

export default dryCleaningHouse;
